import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel'
import { Box } from '@mui/material';
import { useState } from 'react';
import MyAttendanceHistory from './MyAttendanceHistory';

const MyAttendanceLandingPage = ({faceRecogFlow}) => {
    const [value, ] = useState('1');
    // const handleChange = (event, newValue) => {
    //     setValue(newValue);
    // };
    return (
        <Box sx={{ width: '100%' }}>
            <TabContext value={value}>
                {/* <Box>
                    <TabList 
                        sx={{
                            minHeight: "40px", mb: 1, ".MuiTab-root": { minHeight: "20px" },
                            '& .MuiTabs-indicator': {
                                width: '100%',
                                display: 'flex',
                                justifyContent: "center !important",
                            },
                            }} 
                            onChange={handleChange} 
                            aria-label="lab API tabs example"
                            variant="scrollable"
                            orientation="horizontal"
                            allowScrollButtonsMobile={true}
                        >
                        <Tab label="Attendance History" value="1" />
                        <Tab label="Face Attendance" value="2" />
                    </TabList>
                </Box> */}                            
                <TabPanel value="1" sx={{ padding: "0px" }}>
                    <MyAttendanceHistory faceRecogFlow={faceRecogFlow}/>
                </TabPanel>
                {/* <TabPanel value="2" sx={{ padding: "0px" }}>
                    <MyTimeFaceGrid value={"2"} />
                </TabPanel> */}
            </TabContext>
        </Box>
    )
}

export default MyAttendanceLandingPage;